import { URLS } from '@/router/routes/urlRoutes'
import PageNotFoundView from '@/views/PageNotFound/PageNotFoundView.vue'

export const sharedRoutes = [
  {
    path: '/',
    redirect: `/${URLS.DASHBOARD}`
  },
  {
    path: `/${URLS.NOT_FOUND_PAGE}`,
    name: URLS.NOT_FOUND_PAGE,
    component: PageNotFoundView
  },
  {
    path: '*',
    redirect: `/${URLS.NOT_FOUND_PAGE}`
  }
]
